import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as common from 'libs/commonFunc';
import * as licenseLib from 'libs/licenseLib';
import * as licenseActions from 'modules/license';

import { LicenseList } from 'components';

class CtLicenseList extends PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.getLicenseInfo();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.needReload && nextProps.needReload !== this.props.needReload) {
      this.getLicenseInfo();
    }
  }

  getLicenseInfo = async () => {
    const { LicenseActions } = this.props;

    try {
      await LicenseActions.getLicense();
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { isAuth, licenseData, targetAllCount } = this.props;

    let respData = {};
    if (licenseData && Map.isMap(licenseData) && licenseData.get('result') === 1) {
      respData = licenseData.toJS().success;
    }

    return <LicenseList isAuth={isAuth} licenseData={respData} targetAllCount={targetAllCount} />;
  }
}

CtLicenseList.propTypes = {};
CtLicenseList.defaultProps = {};

const mapStateToProps = state => {
  return {
    licenseData: state.license.get('data'),
    targetAllCount: state.license.get('targetAllCount'),
    needReload: state.license.get('needReload'),
    isAuth: state.user.get('isAuth')
    //pageHeight: state.currentStatus.getIn(['etc', 'pageHeight'])
  };
};

const mapDispatchToProps = dispatch => ({
  LicenseActions: bindActionCreators(licenseActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CtLicenseList);



// WEBPACK FOOTER //
// ./src/script/containers/license/CtLicenseList.js